export const DEFAULT_INTERFACE_COLORS = Object.freeze({
  primaryColor: '#17191D', secondaryColor: '#656C78', accentColor: '#2457DB',
})

// Retire defaults, not a customer's identity or deliberately chosen custom color.
const RETIRED_COLORS = new Set(['#D4AF37', '#A9821E', '#8B7355', '#0A84FF', '#30D158', '#BF5AF2', '#A888FF', '#00D4AA', '#FFB800'])
export function normalizeInterfaceBranding(branding = {}) {
  const next = { ...branding }
  for (const [key, fallback] of Object.entries(DEFAULT_INTERFACE_COLORS)) {
    let value = typeof branding[key] === 'string' ? branding[key].trim().toUpperCase() : ''
    if (/^#[0-9A-F]{3}$/.test(value)) value = '#' + [...value.slice(1)].map(char => char + char).join('')
    next[key] = /^#[0-9A-F]{6}$/.test(value) && !RETIRED_COLORS.has(value) ? value : fallback
  }
  return next
}

export function interfaceColorVariables(branding) {
  const colors = normalizeInterfaceBranding(branding)
  const variables = {}
  for (const [key, name] of [['primaryColor', 'primary'], ['secondaryColor', 'secondary'], ['accentColor', 'accent']]) {
    const value = colors[key]
    variables[`--dynamic-${name}`] = value
    variables[`--dynamic-${name}-rgb`] = [1, 3, 5].map(index => parseInt(value.slice(index, index + 2), 16)).join(' ')
  }
  return variables
}
